import { render, staticRenderFns } from "./Textra.vue?vue&type=template&id=4bcd5968&scoped=true"
import script from "./Textra.vue?vue&type=script&lang=js"
export * from "./Textra.vue?vue&type=script&lang=js"
import style0 from "./Textra.vue?vue&type=style&index=0&id=4bcd5968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd5968",
  null
  
)

export default component.exports